import {pullRequestsAppBuilder} from '../config/app-builder'
import type {CommitsRoutePayload} from './Commits'
import {reportTraceData} from '@github-ui/internal-api-insights'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import type {NavigationCounterPageData} from '../page-data/payloads/tab-counts'
import {ResponseError} from '@github-ui/react-core/future/response-error'
import {initialQuery} from '@github-ui/react-core/future/query-configs'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export const pullRequestsCommitsRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsCommitsRoute', {
  path: '/:owner/:repo/pull/:pr_number/commits',
  queries: [
    initialQuery<CommitsRoutePayload>(),
    {
      queryName: 'tabCounts',
      queryDeps: ({params}) => {
        return {pathname: `/${params.owner}/${params.repo}/pull/${params.pr_number}/page_data/tab_counts`}
      },
      queryFn: async ({queryDeps: {pathname}}) => {
        const response = await reactFetchJSON(pathname)
        if (!response.ok) throw new ResponseError(response.statusText, response)
        const json = await response.json()
        reportTraceData(json)
        return json as NavigationCounterPageData
      },
      type: QueryRouteQueryType.Deferred,
    },
  ],
})
